import { render, staticRenderFns } from "./SetAccuracy.vue?vue&type=template&id=ece3e6d0"
import script from "./SetAccuracy.vue?vue&type=script&lang=js"
export * from "./SetAccuracy.vue?vue&type=script&lang=js"
import style0 from "./SetAccuracy.vue?vue&type=style&index=0&id=ece3e6d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports